  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }

$('body').on('click','.body1_cintent', function() {
  console.log('skbvksbvjkskv');
  $(this).children().find('input').prop('checked','checked');
  $('.body1_cintent .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});

$('.shoulder_content').on('click', function() {

  $(this).children().find('input').prop('checked','checked');;
  $('.shoulder_content .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});
$('.shoulder_content1').on('click', function() {

  $(this).children().find('input').prop('checked','checked');;
  $('.shoulder_content1 .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});
$('.shoulder_content3').on('click', function() {

  $(this).children().find('input').prop('checked','checked');;
  $('.shoulder_content3 .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});

$('.pannel_content').on('click', function() {
  $(this).children().find('input').prop('checked','checked');;
  $('.pannel_content .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});

$('.pannel_content1').on('click', function() {
  $(this).children().find('input').prop('checked','checked');;
  $('.pannel_content1 .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});

$('.pannel_content2').on('click', function() {
  $(this).children().find('input').prop('checked','checked');;
  $('.pannel_content2 .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});


$('.pannel_content3').on('click', function() {
  $(this).children().find('input').prop('checked','checked');;
  $('.pannel_content3 .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});

$('.pannel_content4').on('click', function() {
  $(this).children().find('input').prop('checked','checked');;
  $('.pannel_content4 .radio-toolbar label').removeClass('selected');
  $(this).children('.radio-toolbar').children().addClass('selected');
});

  // metafield modal
//   $('.openmodale').click(function (e) {
//     e.preventDefault();
//     $('.modale').addClass('opened');
//   });
//   $('.closemodale').click(function (e) {
//     e.preventDefault();
//     $('.modale').removeClass('opened');
//   });

  // tab
  $('.modale .tabs-stage div').hide();
  $('.modale .tabs-stage div:first').show();
  $('.modale .tabs-nav li:first').addClass('tab-active');

  // Change tab class and display content
  $('.modale .tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.modale .tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.modale .tabs-stage div').hide();
    $($(this).attr('href')).show();
  });

  // sizeopenmodale
  
  $('.sizeclosemodale').click(function (e) {
    e.preventDefault();
    $('.sizemodale').removeClass('opened');
  });

  $('.sizemodale .tabs-stage div').hide();
  $('.sizemodale .tabs-stage div:first').show();
  $('.sizemodale .tabs-nav li:first').addClass('tab-active');

  // Change tab class and display content
  $('.sizemodale .tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.sizemodale .tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.sizemodale .tabs-stage div').hide();
    $($(this).attr('href')).show();
  });



  // shoulderguide
  $('.shoulderguide').click(function (e) {
    e.preventDefault();
    $('.shouldermodale').addClass('opened');
  });
  $('.shoulderclosemodale').click(function (e) {
    e.preventDefault();
    $('.shouldermodale').removeClass('opened');
  });

  $('.shouldermodale .tabs-stage div').hide();
  $('.shouldermodale .tabs-stage div:first').show();
  $('.shouldermodale .tabs-nav li:first').addClass('tab-active');

  // Change tab class and display content
  $('.shouldermodale .tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.shouldermodale .tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.shouldermodale .tabs-stage div').hide();
    $($(this).attr('href')).show();
  });

  // Preferred Fit Guide
  $('.preferredguide').click(function (e) {
    e.preventDefault();
    $('.preferredmodale').addClass('opened');
  });
  $('.preferredclosemodale').click(function (e) {
    e.preventDefault();
    $('.preferredmodale').removeClass('opened');
  });

  $('.preferredmodale .tabs-stage div').hide();
  $('.preferredmodale .tabs-stage div:first').show();
  $('.preferredmodale .tabs-nav li:first').addClass('tab-active');

  // Change tab class and display content
  $('.preferredmodale .tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.preferredmodale .tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.preferredmodale .tabs-stage div').hide();
    $($(this).attr('href')).show();
  });

// sholder
$('.shoulderguide').click(function (e) {
  e.preventDefault();
  $('.shouldermodale').addClass('opened');
});
$('.shoulderclosemodale').click(function (e) {
  e.preventDefault();
  $('.shouldermodale').removeClass('opened');
});

$('.shouldermodale .tabs-stage div').hide();
$('.shouldermodale .tabs-stage div:first').show();
$('.shouldermodale .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.shouldermodale .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.shouldermodale .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.shouldermodale .tabs-stage div').hide();
  $($(this).attr('href')).show();
});



// fit
$('.fitguide').click(function (e) {
    e.preventDefault();
    $('.fitmodale').addClass('opened');
  });
  $('.fitclosemodale').click(function (e) {
    e.preventDefault();
    $('.fitmodale').removeClass('opened');
  });

  $('.fitmodale .tabs-stage div').hide();
  $('.fitmodale .tabs-stage div:first').show();
  $('.fitmodale .tabs-nav li:first').addClass('tab-active');

  // Change tab class and display content
  $('.fitmodale .tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.fitmodale .tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.fitmodale .tabs-stage div').hide();
    $($(this).attr('href')).show();
  });




// end Accordian Section 
function mysizeselectFunction() {
  var x = document.getElementById("selectsizemenu");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

// side bar size
$(document.body).on('click', '.product-popup-modal__button', function() {
  $(".sidebar_size").toggleClass('is-shift-sidebar');
  $("body").toggleClass('sc-overlay');
});
$(document.body).on('click', '.close_sidebar', function() {
  $(".sidebar_size").removeClass('is-shift-sidebar');
    $("body").removeClass('sc-overlay');
});


//
// $(document).ready(function(){

//   $(".cnew-check-radio").on("click",function(){
//     if($(this).parent().parent().parent().children('.grid-product__content').children('.grid-product__meta').children('.you-may').children('form').children('.inlinesleeve').children('label').children('input:checked').val()== undefined  
//       ){
//       $(this).parent().parent().parent().children(".grid-product__content").children(".grid-product__meta").children(".you-may").children(".sleevlenght-margin").children(".new-check-radio-errow").css("display" , "block");
//     }

//   });
//   $('.inlinesleeve :radio').on('click',function(){
//     if($(this).parent().parent().parent().parent().children('.lenght-heading').children('.new-check-radio-errow').css('display') == 'block' )
//     {
//       $(this).parent().parent().parent().parent().children('.lenght-heading').children('.new-check-radio-errow').css('display','none');
//     }
//     $(this).parent().parent().parent().parent().parent().parent().parent().children('.grid-product-footer').children('.mr-product-grid-addcart-btn').children('.cnew-check-radio').css('display','none'); 
//     $(this).parent().parent().parent().parent().parent().parent().parent().children('.grid-product-footer').children('.mr-product-grid-addcart-btn').children('.new-check-radio').css('display','block'); 
//   });  

//   $('.variant-viewsection').on('click',function(){
//     $(this).parent().children('.mr-quickview-btn-out').css('display','block');
//     $(this).parent().children('.mr-product-grid-addcart-btn').css('display','block');
//     $(this).parent().children('.variant-viewsection').css('display','none');
//   }); 



//   $('.btn.btn--full.custom-buynow-btn').on('click',function(){
//     var abc = $('.product-single__form .area-main-fields')[0].offsetTop;
//     if(screen.width < 767)
//     {
//       window.scrollTo({
//         top: abc-abc/6,
//         behavior: 'smooth',
//       })
//     }
//   });

//   $('.btn.btn--full.custom-cart-btn').on('click',function(){
//     var abc = $('.product-single__form .area-main-fields')[0].offsetTop;
//     if(screen.width < 767)
//     {
//       window.scrollTo({
//         top: abc-abc/6,
//         behavior: 'smooth',
//       })
//     }
//   });

//   $('.goes-well').slick({
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     dots:false,
//     arrows: true,
//     centerMode: false,
//     responsive: [{
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//       }

//     }, 
//                  {
//                    breakpoint: 800,
//                    settings: {
//                      slidesToShow: 2,
//                      slidesToScroll: 2,
//                      dots: false,
//                      infinite: true,

//                    }
//                  },  
//                  {
//                    breakpoint: 560,
//                    settings: {
//                      slidesToShow: 1,
//                      slidesToScroll: 1,
//                      dots: false,
//                      infinite: true,
//                      autoplay: true,
//                      autoplaySpeed: 2000,
//                    }
//                  }]
//   }); 


//   $('.you-may-also').slick({
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     dots:false,
//     arrows: true,
//     centerMode: false,
//     responsive: [{
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//       }

//     }, 
//                  {
//                    breakpoint: 800,
//                    settings: {
//                      slidesToShow: 2,
//                      slidesToScroll: 2,
//                      dots: false,
//                      infinite: true,

//                    }
//                  },  
//                  {
//                    breakpoint: 560,
//                    settings: {
//                      slidesToShow: 1,
//                      slidesToScroll: 1,
//                      dots: false,
//                      infinite: true,
//                      autoplay: true,
//                      autoplaySpeed: 2000,
//                    }
//                  }]
//   }); 



//   $('.customr-review-box').slick({
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     dots:false,
//     centerMode: false,
//     responsive: [{
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//       }

//     }, 
//                  {
//                    breakpoint: 800,
//                    settings: {
//                      slidesToShow: 2,
//                      slidesToScroll: 2,
//                      dots: false,
//                      infinite: true,

//                    }
//                  },  
//                  {
//                    breakpoint: 480,
//                    settings: {
//                      slidesToShow: 1,
//                      slidesToScroll: 1,
//                      dots: false,
//                      infinite: true,
//                      autoplay: true,
//                      autoplaySpeed: 2000,
//                    }
//                  }]
//   }); 


//   $("#customemudropdown .getvalue1").mouseenter(function(){    
//     let topmain_menu1 = $(this).text();  
//     if(topmain_menu1 == "Men's Accessories"){
//       $("#shopcategorymenu1").css("display","block");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu1").mouseleave(function(){
//     $("#shopcategorymenu1").css("display","none");
//   });  
//   $("#customemudropdown .getvalue2").mouseenter(function(){    
//     let topmain_menu2 = $(this).text();  
//     if(topmain_menu2 == "Custom Orders"){
//       $("#shopcategorymenu2").css("display","block");
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu2").mouseleave(function(){
//     $("#shopcategorymenu2").css("display","none");
//   });


//   $("#customemudropdown .getvalue3").mouseenter(function(){    
//     let topmain_menu3 = $(this).text();  
//     if(topmain_menu3 = "Collaborations & Reviews"){
//       $("#shopcategorymenu3").css("display","block");      	
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu3").mouseleave(function(){
//     $("#shopcategorymenu3").css("display","none");
//   });  
//   $("#customemudropdown .getvalue4").mouseenter(function(){    
//     let topmain_menu4 = $(this).text();  
//     if(topmain_menu4 = "Abouts Us"){
//       $("#shopcategorymenu4").css("display","block");
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu4").mouseleave(function(){
//     $("#shopcategorymenu4").css("display","none");
//   });

//   //   Workation
//   $("#customemudropdown .getvalue5").mouseenter(function(){    
//     let topmain_menu5 = $(this).text();  
//     if(topmain_menu5 = "Workation Wear"){
//       $("#shopcategorymenu5").css("display","block");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu5").mouseleave(function(){
//     $("#shopcategorymenu5").css("display","none");
//   });
//   //   Workation end

//   //   20-11-2020
//   $("#customemudropdown .getvalue6").mouseenter(function(){    
//     let topmain_menu6 = $(this).text();  
//     if(topmain_menu6 = "Leather Accessories"){
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu6").css("display","block");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu6").mouseleave(function(){
//     $("#shopcategorymenu6").css("display","none");
//   });
//   //   20-11-2020 end


//   //   24-11-2020
//   $("#customemudropdown .getvalue7").mouseenter(function(){    
//     let topmain_menu7 = $(this).text();  
//     if(topmain_menu7 = "Face Masks"){
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu7").css("display","block");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu7").mouseleave(function(){
//     $("#shopcategorymenu7").css("display","none");
//   });
//   //   24-11-2020

//   //   18-1-2021
//   $("#customemudropdown .getvalue8").mouseenter(function(){    
//     let topmain_menu8 = $(this).text();  
//     if(topmain_menu8 = "Cotton Shirts"){
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");
//       $("#shopcategorymenu9").css("display","none");
//     }
//   });  
//   $("#shopcategorymenu8").mouseleave(function(){
//     $("#shopcategorymenu8").css("display","none");
//   });
//   //   18-1-2021

//   $("#customemudropdown .getvalue9").mouseenter(function(){    
//     let topmain_menu9 = $(this).text();  
//     if(topmain_menu9 = "Custom Made Shirts"){
//       $("#shopcategorymenu9").css("display","none");
//       $("#shopcategorymenu5").css("display","none");
//       $("#shopcategorymenu4").css("display","none");
//       $("#shopcategorymenu1").css("display","none");
//       $("#shopcategorymenu2").css("display","none");
//       $("#shopcategorymenu3").css("display","none");
//       $("#shopcategorymenu6").css("display","none");
//       $("#shopcategorymenu7").css("display","none");
//       $("#shopcategorymenu8").css("display","none");

//     }
//   });  
//   $("#shopcategorymenu9").mouseleave(function(){
//     $("#shopcategorymenu9").css("display","none");
//   });

//   $(".formegamenuhide").hover(function(){ 
//     $("#shopcategorymenu4").css("display","none");
//     $("#shopcategorymenu1").css("display","none");
//     $("#shopcategorymenu2").css("display","none");
//     $("#shopcategorymenu3").css("display","none");
//     $("#shopcategorymenu5").css("display","none");
//     $("#shopcategorymenu6").css("display","none");
//     $("#shopcategorymenu7").css("display","none");
//     $("#shopcategorymenu8").css("display","none");
//     $("#shopcategorymenu9").css("display","none");
//   }); 

//   //   $("#select_typeproduct label").on("click", function(){
//   //     let select_typeproduct = $(this).prev().val();
//   //     if(select_typeproduct == "Pocket Square"){ 
//   //       $("#select_typeproduct .selecttype1").addClass("selectTypeactive");
//   //       $("#select_typeproduct .selecttype2").removeClass("selectTypeactive");
//   //     }else if(select_typeproduct == "Tie + Pocket Square"){ 
//   //       $("#select_typeproduct .selecttype1").removeClass("selectTypeactive");
//   //       $("#select_typeproduct .selecttype2").addClass("selectTypeactive");

//   //     }else{}  
//   //   });





//   $('#select_typeproduct input:radio[name="properties[Select Type]"]').change(function(){
//     if($(this).is(":checked")){ 
//       $('html, body').animate({scrollTop:400}, 'slow');
//       $(this).next(".selecttype").addClass("selectTypeactive");
//       $(this).next(".selecttype").siblings().removeClass('selectTypeactive');
//       return false;      
//     }
//   });  

//   $('#choose_design_product input:radio[name="properties[Design]"]').change(function(){
//     if($(this).is(":checked")){
//       $('html, body').animate({scrollTop:600}, 'slow');
//       $(this).next(".designclass").addClass("activedesign");
//       $(this).next(".designclass").siblings().removeClass('activedesign');
//       return false;      
//     }
//   });
//   $('#choose_fold_product input:radio[name="properties[Fold]"]').change(function(){
//     if($(this).is(":checked")){  
//       $('html, body').animate({scrollTop:800}, 'slow');
//       $(this).next(".foldclass").addClass("activefold");
//       $(this).next(".foldclass").siblings().removeClass('activefold');
//       return false;      
//     }
//   });  


//   $('#custom-about-us--banner__id').parent().parent().parent().addClass('custom-about-us__class');



//   $("#FilterDrawer .collectionfiltercustom").on("click", function(){
//     setTimeout(function(){ 
//       location.reload();
//     }, 500);  
//   });  



// });


// if($(window).width() > 768 ){
//   let headerHeight_custom = $(".site-header").height();
//   let headerHeight_sub_custom = $(".mr-desktop-nav").height();
//   let menu_scroll_height_custom = headerHeight_custom - headerHeight_sub_custom;


//   $(window).scroll(function(){
//     if ($(window).scrollTop() >= menu_scroll_height_custom ) {          
//       //$(".mr-desktop-nav").css({'top': '0px' ,'position': 'fixed','z-index':'999'});                
//     }
//     else {        
//       $(".mr-desktop-nav").css({'top':'0px','position': 'unset','z-index':'10'});       //position:'relative'
//     }
//   }); 


// };

// if($(window).width() <= 767){
// };


// $(document).ready(function() {

//   $('#topbar-owl').owlCarousel({
//     loop: true,
//     margin: 10,
//     responsiveClass: true,
//     autoplay:true,
//     autoplayTimeout:5000,
//     dots: false,
//     responsive: {
//       0: {
//         items: 1,
//         nav: true
//       },
//       600: {
//         items: 1,
//         nav: false
//       },
//       1000: {
//         items:1,
//         loop:true,
//         margin:10,

//       }
//     }
//   });
// });


// $(document).ready(function() {
//   $('.owl-carousel').owlCarousel({
//     loop: true,
//     margin: 10,
//     responsiveClass: true,
//     responsive: {
//       0: {
//         items: 1,
//         nav: true
//       },
//       600: {
//         items: 1,
//         nav: false
//       },
//       1000: {
//         items: 3,
//         nav: true,
//         dots: false,
//         loop: false,
//         margin: 10
//       }
//     }
//   });


// });


// //  added by sarmistha 11-9-2020
// $('.grid-product__price div:first-child').removeClass('clicked-hide').addClass('clicked');
// $('.grid-product__price div').addClass('clicked-hide');

// $('.collections-variants li:first-child').removeClass('clicked-hides').addClass('clickeds');
// $('.collections-variants li').addClass('clicked-hides');

// $('.variant-images li:first-child').removeClass('clicked-hidei').addClass('clickedi');
// $('.variant-images li').addClass('clicked-hidei');

// $('.collections-variants li').click(function(){
//   $(this).addClass('highlightclick').siblings().removeClass('highlightclick');
// });


// // $('.mr-product-grid-addcart-btn form').addClass('form-hide');
// // $('.mr-product-grid-addcart-btn form:first-child').removeClass('form-hide').addClass('form-show');

// $('.carticonbtn').click(function(){
//   $(this).parent().parent().toggleClass('variantform');
// });

// $('.collections-variants li').click(function() {
//   var myEm = $(this).attr('data-my-element');

//   $('.mr-product-grid-addcart-btn form[data-my-element = '+myEm+']').removeClass('form-hide').addClass('form-show').siblings().removeClass('form-show').addClass('form-hide');

//   $('.variant-images li[data-my-element = '+myEm+']').removeClass('clicked-hidei').addClass('clickedi').siblings().removeClass('clickedi').addClass('clicked-hidei');

//   $('.grid-product__price div[data-my-element = '+myEm+']').removeClass('clicked-hide').addClass('clicked').siblings().removeClass('clicked').addClass('clicked-hide');

//   $(this).removeClass('clicked-hides').addClass('clickeds').siblings().removeClass('clickeds').addClass('clicked-hides');
// });  


// $('.collections-variants li:has(a:contains("Default Title"))').css('display', 'none');
// $('#CollectionAjaxResult li:has(a:contains("Default Title"))').css('display', 'none');

// if ($(window).width() < 812)
// {
//   $('.pro').slick({
//     dots: true,
//     infinite: false,
//     arrows: true,
//     dots: true,
//     fade: false,
//     autoplay: true,
//     speed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     //   responsive: [
//     //     {
//     //       breakpoint: 1024,
//     //       settings: {
//     //         slidesToShow: 1,
//     //         slidesToScroll: 1,
//     //         infinite: true,
//     //         dots: true
//     //       }
//     //     },
//     //     {
//     //       breakpoint: 600,
//     //       settings: {
//     //         slidesToShow: 1,
//     //         slidesToScroll: 1
//     //       }
//     //     },
//     //     {
//     //       breakpoint: 480,
//     //       settings: {
//     //         speed: 300,
//     //         infinite: true,
//     //         autoplay: false,
//     //         fade: false,
//     //         slidesToShow: 1,
//     //         slidesToScroll: 1
//     //       }
//     //     }
//     //   ]
//   });
// }

// if ($(window).width() < 812){
//   $('#modal_slider').slick({
//     dots: true,
//     infinite: false,
//     arrows: true,
//     fade: false,
//     autoplay: true,
//     speed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1
//   });
// }

// $( ".sizeguide" ).insertBefore( ".payment-buttons" );
// $(".sizegudeimg-tem").insertAfter( ".half-div" );
// $(".made-to-measure").insertAfter( ".half-div label:last-child" );


// $( "#shopify-section-customerreview" ).insertBefore( ".main-area" );



// $(".centersections-image").parents().addClass('hidesectionreview');

// $( ".modal--is-active .product_desc_bns" ).insertAfter( ".modal--is-active .productpage_bg_cont" );


// // 2-11-2020
// if ($(window).width() > 1025)
// {
//   function zoom(e){
//     var zoomer = e.currentTarget;
//     zoomer.style.backgroundPositionX = -e.offsetX + "px";
//     zoomer.style.backgroundPositionY = -e.offsetY + "px";
//   }
// };


// // demo
// $('.collection-sidebar__group .tag-list>.tag.tag--active')
// $('li.tag.tag-').parents('body').addClass('slamdown'); 
// if ($('.collection-sidebar__group .tag-list li.tag').hasClass('tag--active')){
//   $('li.tag.tag--active').parents('body').addClass('slamdown');  /* missing . before removeClass */
// } else {
//   $('li.tag.tag--active').parents("body").removeClass('slamdown');
// }


// // date picker
// function onlyTheseWeekDays(arr) {
//   var days = [];
//   if (arr instanceof Array) {
//     days = arr;
//   } else if (!isNaN(Number(arr))) {
//     days.push(arr);
//   }
//   return function (date) {
//     var dayOfWeek = date.getDay(),
//         i;
//     for (i = 0; i < days.length; i += 1) {
//       if (days[i] === dayOfWeek) {
//         return [true];
//       }
//     }
//     return [false];
//   }
// }

// jQuery(document).ready(function($) {
//   $("#date").datepicker({ 
//     minDate: +1, 
//     maxDate: '+2M',
//     dateFormat: 'MM d yy',
//     dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
//     //beforeShowDay: onlyTheseWeekDays([1, 2, 3, 4, 5, 6])
//     beforeShowDay: function(date) {
//       var day = date.getDay();
//       var array = [""];
//       var string = jQuery.datepicker.formatDate('dd-mm-yy', date);
//       return [(day != 0) && array.indexOf(string) == -1];
//     },
//   })
//   $('#ui-datepicker-div').css('clip', 'auto'); 
// });




// metafield modal
// $('.openmodale').click(function (e) {
//   e.preventDefault();
//   $('.modale').addClass('opened');
// });
// $('.closemodale').click(function (e) {
//   e.preventDefault();
//   $('.modale').removeClass('opened');
// });

// tab
$('.modale .tabs-stage div').hide();
$('.modale .tabs-stage div:first').show();
$('.modale .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.modale .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.modale .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.modale .tabs-stage div').hide();
  $($(this).attr('href')).show();
});

// sizeopenmodale

$('.sizeopenmodale').on('click', function (e) {
  e.preventDefault();
  $('.sizemodale').addClass('opened');
});
$('.sizeclosemodale').click(function (e) {
  e.preventDefault();
  $('.sizemodale').removeClass('opened');
});

// Size tabs 

$('.size-guide-tabs .size-guide-tab').on('click', function(event) {
  event.preventDefault();
  var $this = $(this);
  if($this.hasClass('size-guide-tab-inch')) {
    
    $('.size-guide-tab-cm').removeClass('active');
    $this.addClass('active');
    $('.sizeIn_inch').show();
    $('.sizeonlycm').hide();

  }else {

    $('.size-guide-tab-inch').removeClass('active');
    $this.addClass('active');
    $('.sizeIn_inch').hide();
    $('.sizeonlycm').show();
  }
});

$('.sizemodale .tabs-stage div').hide();
$('.sizemodale .tabs-stage div:first').show();
$('.sizemodale .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.sizemodale .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.sizemodale .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.sizemodale .tabs-stage div').hide();
  $($(this).attr('href')).show();
});



// shoulderguide
$('.shoulderguide').click(function (e) {
  e.preventDefault();
  $('.shouldermodale').addClass('opened');
});
$('.shoulderclosemodale').click(function (e) {
  e.preventDefault();
  $('.shouldermodale').removeClass('opened');
});

$('.shouldermodale .tabs-stage div').hide();
$('.shouldermodale .tabs-stage div:first').show();
$('.shouldermodale .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.shouldermodale .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.shouldermodale .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.shouldermodale .tabs-stage div').hide();
  $($(this).attr('href')).show();
});


// height
$('.heightguide').click(function (e) {
  e.preventDefault();
  $('.heightmodale').addClass('opened');
});
$('.heightclosemodale').click(function (e) {
  e.preventDefault();
  $('.heightmodale').removeClass('opened');
});

$('.heightmodale .tabs-stage div').hide();
$('.heightmodale .tabs-stage div:first').show();
$('.heightmodale .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.heightmodale .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.heightmodale .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.heightmodale .tabs-stage div').hide();
  $($(this).attr('href')).show();
});

// Preferred Fit Guide
$('.preferredguide').click(function (e) {
  e.preventDefault();
  $('.preferredmodale').addClass('opened');
});
$('.preferredclosemodale').click(function (e) {
  e.preventDefault();
  $('.preferredmodale').removeClass('opened');
});

$('.preferredmodale .tabs-stage div').hide();
$('.preferredmodale .tabs-stage div:first').show();
$('.preferredmodale .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.preferredmodale .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.preferredmodale .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.preferredmodale .tabs-stage div').hide();
  $($(this).attr('href')).show();
});

// Sleeves
$('.sleevesguide').click(function (e) {
  e.preventDefault();
  $('.sleevesmodale').addClass('opened');
});
$('.sleevesclosemodale').click(function (e) {
  e.preventDefault();
  $('.sleevesmodale').removeClass('opened');
});

$('.sleevesmodale .tabs-stage div').hide();
$('.sleevesmodale .tabs-stage div:first').show();
$('.sleevesmodale .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.sleevesmodale .tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.sleevesmodale .tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.sleevesmodale .tabs-stage div').hide();
  $($(this).attr('href')).show();
});

$('.smothlyscrool').click(function(event){
  $('html, body').animate({
    scrollTop: $( $.attr(this, 'href') ).offset().top - 70
  }, 500);
  event.preventDefault();
});




var isShirtSize =false;
var isAppointmentBook=false;
var isTimeSlot=false;
var isDateSlot=false;

$(".requerd-s").append("<p class='option-error' style='color: red;font-size: 11px !important;text-transform: capitalize;font-weight:bold'>* Select Size</p>");
$(".requerd-se").append("<p class='option-error' style='color: red;font-size: 11px !important;text-transform: capitalize;font-weight:bold'>* Select Time Slot</p>");
$(".requerd-date").append("<p class='option-error' style='color: red;font-size: 11px !important;text-transform: capitalize;font-weight:bold'>* Select Date</p>");

hideValidationErrors();
hideDuplicateBuyNowButtonStitched();


// Individual onclick option for custom stitched option
$('.checked-radiosize').click(function() {
  $(".requerd-s").hide();
  isShirtSize =true; 
  hideDuplicateBuyNowButtonStitched();
});

$('.checked-radiotime').click(function() {
  $(".requerd-se").hide();
  isTimeSlot=true;
  hideDuplicateBuyNowButtonStitched();
});

$('.checked-date').click(function() {
  $(".requerd-date").hide();
  isDateSlot=true;
  hideDuplicateBuyNowButtonStitched();
});


// Add to cart button validation check for custom stitched
$(".payment-buttons button").click(function (e) {
  validateCustomStitchedOnClick();
  hideDuplicateBuyNowButtonStitched();
});


// custom buy now validation check
$(".custom-buynow-btn").click(function (e) {
  validateCustomStitchedOnClick();
  hideDuplicateBuyNowButtonStitched();

});

$(".custom-cart-btn").click(function (e) {
  validateCustomStitchedOnClick();
  hideDuplicateBuyNowButtonStitched();

});



$("body").on("click",".giftcheck input", function (e) {
if($('#gift_ys1').is(":checked")){
  $("#gift_ys1").attr("value","Yes");
}else{
$("#gift_ys1").removeAttr("value");
}  
if($('#gift_no1').is(":checked")){
  $("#gift_no1").attr("value","No");
}else{
$("#gift_no1").removeAttr("value");  
}
  
if($('#gift_ys').is(":checked")){
  $("#gift_ys").attr("value","Yes");
}else{
$("#gift_ys").removeAttr("value");
}  
if($('#gift_no').is(":checked")){
  $("#gift_no").attr("value","No");
}else{
$("#gift_no").removeAttr("value");  
}  
  
  
}); 



//   hide and show custom duplicate buy button
function hideDuplicateBuyNowButtonStitched(){

  if(isAppointmentBook){

    if  ( isShirtSize && isTimeSlot && isDateSlot){
      $(".custom-buynow-btn").hide();
      $(".custom-buynow .shopify-payment-button").show();

      $(".custom-cart-btn").hide();
      $(".custom-buynow .add-to-cart").show();

    }else{
      $(".custom-buynow-btn").show();
      $(".custom-buynow .shopify-payment-button").hide();

      $(".custom-cart-btn").show();
      $(".custom-buynow .add-to-cart").hide();

    }
  }

  else{
    if  ( isShirtSize ){
      $(".custom-buynow-btn").hide();
      $(".custom-buynow .shopify-payment-button").show();

      $(".custom-cart-btn").hide();
      $(".custom-buynow .add-to-cart").show();

    }else{
      $(".custom-buynow-btn").show();
      $(".custom-buynow .shopify-payment-button").hide();

      $(".custom-cart-btn").show();
      $(".custom-buynow .add-to-cart").hide();
    }}
}

function validateCustomStitchedOnClick(){
  if (!$('input[name="properties[Size]"]').is(':checked')) {
    $(".requerd-s").show();
    isShirtSize=false;
  }else{
    isShirtSize=true;
  }

  validateMyAppointmentBook();

}

function validateMyAppointmentBook(){
  if(isAppointmentBook)
  {
    if (!$('input[name="properties[Time]"]').is(':checked')) {
      $(".requerd-se").show();
      isTimeSlot=false;
    }else{
      isTimeSlot=true;
    }

    if (!$("#date").datepicker("getDate")) {
      $(".requerd-date").show();
      isDateSlot=false;
    }else{
      $(".requerd-date").hide();
      isDateSlot=true;
    }

  }else{
    isAppointmentBook=false;
    isTimeSlot=false;
    isDateSlot=false;
  }

  hideDuplicateBuyNowButtonStitched()
}

function hideValidationErrors() {
  $(".requerd-f").hide();
  $(".requerd-s").hide(); 
  $(".requerd-t").hide(); 
  $(".requerd-fo").hide();
  $(".requerd-fi").hide(); 
  $(".requerd-si").hide(); 
  $(".requerd-se").hide();
  $(".requerd-date").hide();
}



// review placement
$( "#pagebottom-revicejudgeme" ).insertBefore( "#reviejudge" );




// shirt page validation
var islenght=false;
$(".requerd-lenght").append("<p class='option-error' style='display:inline;color: red;font-weight:bold;font-size: 11px !important;text-transform: capitalize;'>* Select Sleeves</p>");
hideValidationError();
hideDuplicateBuyButton();
var inputradio1 = 0;
var inputradio2 = 0;

$('.variant-input-wrap .variant__button-label').click(function(){
  if(inputradio1 == 0){
    inputradio1 = 1;
  }
  inputradio();
});

$('.checked-radiolenght').click(function() {
  if(inputradio2 == 0){
    inputradio2 = 1;
  }
  inputradio();        
});

function inputradio(){

  if(inputradio1 == 1 && inputradio2 == 1){
    $(".requerd-lenght").hide();
    islenght =true;
    hideDuplicateBuyButton();
  }
}


function hideDuplicateBuyButton() {
  if  (islenght){
    $(".custom-buynow-btnn").hide();
    $(".paymentbtn-default .shopify-payment-button").show();

    $(".custom-cart-btn").hide();
    $(".custom-buynow .add-to-cart").show();

  }else{
    $(".custom-buynow-btnn").show();
    $(".paymentbtn-default .shopify-payment-button").hide();

    $(".custom-cart-btn").show();
    $(".custom-buynow .add-to-cart").hide();
  }
}

function hideValidationError() {
  $(".requerd-lenght").hide(); 
}
function validateCustomClick(){
  if (inputradio1 == 1 && inputradio2 == 1){
    islenght=true;
  }else{
    islenght=false;
    $(".requerd-lenght").show();
  }
}

// Add to cart button validation check for custom stitched
$(".paymentbtn-default button").click(function (e) {
  validateCustomClick();
  hideDuplicateBuyButton();
});
// custom buy now validation check
$(".custom-buynow-btnn").click(function (e) {
  validateCustomClick();
  hideDuplicateBuyButton();

});

$(".custom-cart-btn").click(function (e) {
  validateCustomClick();
  hideDuplicateBuyButton();

});


// checkbox check show div
$(".bookappointment-field").slideUp();
//$("#checkbox-open").removeAttr("checked", "false");
$("#checkbox-open").click(function() {
  if($(this).is(":checked")) {
    $(".bookappointment-field").slideDown();
    $(".checked-radiotime").attr("required", "true");
    isAppointmentBook=true;

    $('#date').attr('required', 'true');
    $(".datepickers").show();
    $(this).parent().addClass('selected');
  } else {
    $(".bookappointment-field").slideUp();
    $(".checked-radiotime").prop("checked",false);
    $(".checked-radiotime").removeAttr("required", "true");

    isAppointmentBook=false;
    $('#date').removeAttr('required', 'true');
    $('#date').datepicker('setDate', null);
  }
});
// if (!$('.bookappointment input[type="checkbox"]').is(':checked')){
//     $('.bookappointment-field').slideUp();
// }


// faq
$(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find('.article-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.accordion-container'), false);
});

$(document).on('click', function (event) {
  if (!$(event.target).closest('#accordion').length) {
    //$this.parent().toggleClass('open');
  }
});


$(".Property__Field").parents('.mainfields').addClass('displayparent');
$(".displayparent").parents('.area-main-fields').removeClass('displaynone');
if ($('.area-main-fields').hasClass('displaynone')){
  $('.custom-buynow-btn').addClass('removebtn');
  $('.shopify-payment-button').addClass('showbtn');

  $('.custom-cart-btn').addClass('removebtn');
  $('.custom-buynow .add-to-cart').addClass('showbtn');

} else {
  $('.custom-buynow-btn').removeClass('removebtn');
  $('.shopify-payment-button').removeClass('showbtn');

  $('.custom-cart-btn').removeClass('removebtn');
  $('.custom-buynow .add-to-cart').removeClass('showbtn');
}

// stiky header
$(window).scroll(function(){
  var sticky = $('.site-header'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixedheader');
  else sticky.removeClass('fixedheader');
});

// customform
// Get the modal
var modal = document.getElementById("myModalform");

// Get the button that opens the modal
var btn = document.getElementById("myBtnform");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("closeform")[0];

// When the user clicks the button, open the modal 
// btn.onclick = function() {
//   modal.style.display = "block";
// }

$("#myBtnform").click(function(){

  $("#myModalform").show();
});

// When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }
$(".closeform").click(function(){
  $("#myModalform").hide();
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}


function onlyNumberKey(evt) { 

  // Only ASCII charactar in that range allowed 
  var ASCIICode = (evt.which) ? evt.which : evt.keyCode 
  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) 
    return false; 
  return true; 
} 


// sizeguide
// Get the modal
var modall = document.getElementById("mmyModalformal");

// Get the button that opens the modal
var btnn = document.getElementById("mmyBtnformal");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
// btnn.onclick = function() {
//   modall.style.display = "block";
// }
// // When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modall.style.display = "none";
// }

//   $(document).ready(function(){
//   $("#mmyBtnformal").click(function(){
//       $("#mmyModalformalform").show();  
//   });
// });

// // When the user clicks on <span> (x), close the modal
// // span.onclick = function() {
// //   modall.style.display = "none";
// // }
// $(".close").click(function(){
// $("#mmyModalformalform").hide();
// });


$("#mmyBtnformal").click(function(){

  $("#mmyModalformal").show();
});

// When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }
$(".close").click(function(){app://resources/notifications.html#
                             $("#mmyModalformal").hide();
                            });


// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modall) {
    modall.style.display = "none";
  }
}

// home howit 20-3-2021

// $('#homehowitwork').owlCarousel({
//   loop: false,
//   margin: 10,
//   responsiveClass: true,
//   autoplay:false,
//   autoplayTimeout:5000,
//   dots: false,
//   nav: true,
//   responsive: {
//     0: {
//       items: 1,
//       nav: false,
//       dots: true
//     },
//     600: {
//       items: 1,
//       nav: false,
//       dots: true
//     },
//     768: {
//       items: 2,
//       nav: false,
//       dots: true
//     },
//     1000: {
//       items:2,
//       loop:false,
//       margin:10,

//     },
//     1025: {
//       items:3,
//       loop:false,
//       margin:10,

//     }
//   }
// });

// facebook track
$('#BodyType__Average').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__Healthy').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__Athletic').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__36').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__38').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__40').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__42').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__44').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__46').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__48').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__shoulderAverage').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__shoulderSloping').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’0').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’1').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’2').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’3').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’4').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’5').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’6').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’7').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’8').click(function() {
  fbq('track', 'customization');
});

$('#BodyType__5’9').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’10').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__5’11').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__6’0').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__6’1').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__6’2').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__6’3').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__6’4').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__6’5').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__6’6').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__Slim').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__Regular').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__Full').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__Half').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__11:00am - 1:00 pm').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__1:00pm - 3:00pm').click(function() {
  fbq('track', 'customization');
});
$('#BodyType__3:00pm - 6:00pm').click(function() {
  fbq('track', 'customization');
});
$('#date').click(function() {
  fbq('track', 'customization');
});


// sizegude second template

// Get the modal
var modallSize = document.getElementById("mmyModal");

// Get the button that opens the modal
//var btnn = document.getElementById("mmyBtn");

// Get the <span> element that closes the modal
//var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
// btnn.onclick = function() {
//   modall.style.display = "block";
// }

// When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modall.style.display = "none";
// }
$(document).ready(function(){
  $("#mmyBtn").click(function(){
    modallSize.style.display = "block";  
  });
});
$("#mmyModal .close").click(function(){
  $("#mmyModal").hide();
});
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modall) {
    modall.style.display = "none";
  }
}

$('.collectionRadio input:radio').on("change",function(){

  if($(this).is(":checked")){ 
    var datapid = $(this).attr("data-pid");
    var datavalue = $(this).val();
    $('#grid_footer-'+datapid+' form input[name="properties[Sleeve]"]').val(datavalue);



  }
  else{
  } 
}); 

// $(document).ready(function(){
//   $('.checked-radiolenght-aaa').click(function() {
//     $('.checked-radiolenght-aaa').not(this).prop('checked', false);
//     if($('div.giftcheck:checkbox:checked').length > 0 ){
//       $('.checked-radiolenght-aaa').removeAttr('required');
//     }
//     if($('.checked-radiolenght-aaa').is(':checked')){
//       //I am checked
// //       alert("1");
//     }
//   });
  
// });

// code for variants validation check by Musaib
// product cart form validation.
// #############################
// ###############################
$(document).ready(function(){
  $('.btn.btn--full.custom-buynow-btnn').css('display','block');
  $(".shopify-payment-button").css('display','none');
  var fake=   $('.btn.btn--full.custom-buynow-btnn').css('display');
  var org=   $('.shopify-payment-button').css('display');
  let duo =$('.List__numbers.sizecheck').css('display');
  let ano = $('.area-main-fields').css('display');
  //   when no variant is available, fake is undefined, because it is not rendered.
  //    console.log(fake);
  //     console.log(org);
  //       console.log(duo); 
  //   when neither fake button is rendered nor is org none( we have kept org none at begining ).
  // 1  imples no variant, none org, no line item
  if(fake==undefined && org=='none' && duo==undefined){
    if(ano==undefined){
      $('.shopify-payment-button').css('display','block');}  
  }  
  //       #### CART START ####
  $('.btn.btn--full.add-to-cart.btn--secondary').click(function(e){      
    return checkValid(e); 
  }); //       #### cart End####    
  $('.btn.btn--full.custom-buynow-btnn').click(function(a){
    return checkValidFake(a); 
  });

  function checkValid(e){
    //     console.log('in the function');
    let flag;
    $(".variant-input-wrap").each(function (){
      //             console.log('first started');
      let maiId=$(this).attr('id');
      //             console.log(maiId);
      $('#'+maiId).children('input').each(function () {
        //               console.log('second started');
        if ($(this).prop("checked")) {
          //                      name=$(this).attr('name'); 
          flag='yes';
          //                     console.log('checked it');
          return false;      
        }else{ 
          flag='no';
          //                     console.log('not yet');  
        }
        //               console.log('second end');
      });
      //             console.log('receiving log of second');
      if(flag == 'no'){             
        //              console.log('no selected in first');
        var unsel=  $('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage');
        unsel.css('display','inline');
        //      		$('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage').css('display','inline');
        $('html, body').stop().animate({ 'scrollTop':$(unsel).offset().top+(-300)    }, 800, 'swing', function () {        window.location.hash = targetEle;    });
        //              console.log('returning false in first'); 
        e.preventDefault();
        return false;       
      }else{
        $('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage').css('display','none');
      }
      //                         console.log('first end');            
    });
    return true;
  }
  function checkValidFake(a){
    //          console.log('in the fake check');
    let flag;
    $(".variant-input-wrap").each(function (){
      //             console.log('first started');
      let maiId=$(this).attr('id');
      //             console.log(maiId);
      $('#'+maiId).children('input').each(function () {
        //               console.log('second started');
        if ($(this).prop("checked")) {
          //                      name=$(this).attr('name'); 
          flag='yes';
          //                     console.log('checked it');
          return false;      
        }else{ 
          flag='no';
          //                     console.log('not yet');  
        }
        //               console.log('second end');
      });
      //             console.log('receiving log of second');
      if(flag == 'no'){             
        //              console.log('no selected in first');
        var unsel=  $('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage');
        unsel.css('display','inline');
        //      		$('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage').css('display','inline');
        $('html, body').stop().animate({ 'scrollTop':$(unsel).offset().top+(-300)    }, 800, 'swing', function () {        window.location.hash = targetEle;    });
        //              console.log('returning false in first');
        return false;       
      }else{
        $('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage').css('display','none');
      }
      //                         console.log('first end');            
    });
    //     console.log('each completed');
    if(flag=='no'){
      //       console.log('flag found---NO');
      return false;}else{

        $('.btn.btn--full.custom-buynow-btnn').css('display','none');
        $(".shopify-payment-button").css('display','block');    
        return true;
      }
  }
}); // end document ready
$(".variant-input-wrap").on('change', function() {
  //    console.log('on change triggered');
  //  check sleeves presence either flex or undefined.
  //  error hide/show  
  let flag0,flag1,flag2;
  var name;
  let maiId=$(this).attr('id');
  $(this).children('input').each(function () {
    if ($(this).prop("checked")) {
      name=$(this).attr('name');
      return false;
    }
  });
  if(name != undefined){
    $('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage').css('display','none');
    //      console.log('error message hidden done');
  }
  //   hide show close 
  //   check all variants are checked 
  $(".variant-input-wrap").each(function (){
    //             console.log('each running in trigger');
    let maiId=$(this).attr('id');
    $('#'+maiId).children('input').each(function () {
      if ($(this).prop("checked")) {
        flag0='yes';
        return false;      
      }else{ 
        flag0='no';
      }
    });
    if(flag0 == 'no'){             
      var unsel=  $('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage');
      unsel.css('display','inline');
      $('html, body').stop().animate({ 'scrollTop':$(unsel).offset().top+(-300)    }, 800, 'swing', function () {        window.location.hash = targetEle;    });
      //              console.log('second triggered flag found no');
      return false;       
    }else{
      $('#'+maiId).parents('.fieldPlusSmall').find('.radioMessage').css('display','none');
      //            console.log('first triggered flag is Yes');
    }

  });

  if(flag0=='no'){
    //       console.log('first some flag not checked returning false');
    $('.btn.btn--full.custom-buynow-btnn').css('display','block');
    $(".shopify-payment-button").css('display','none');
    flag1='no';
  }else{
    // console.log('on change triggered and all test passed for variant');        
    flag1='yes';
  }
  var slev=$('.List__numbers.sizecheck').css('display');
  //    console.log(slev);
  // test when both are display--- variant and line item   
  if(flag1=='yes' && slev != undefined ){     

    if(  $('.List__numbers.sizecheck').children('input').prop("checked"))
    {
      flag2='yes';
      //        console.log('sleeve checked');
      $('.btn.btn--full.custom-buynow-btnn').css('display','none');

      $(".shopify-payment-button").css('display','block'); 
    }
    else{
      flag2='no';
      //             console.log('sleeve unchecked');
      $('.btn.btn--full.custom-buynow-btnn').css('display','block');
      $(".shopify-payment-button").css('display','none');
    }
  }
  // test when only variant is available
  if(flag1=='yes' && slev == undefined ){ 
    //         console.log('seleeve undefined');   
    if(flag1=='yes'){
      //       console.log('Master Scan Test Passed');
      //        toggle
      $('.btn.btn--full.custom-buynow-btnn').css('display','none');

      $(".shopify-payment-button").css('display','block');       
    }else{
      //            console.log('Failed Master Scan Test ');
      //        dont toggle
      $('.btn.btn--full.custom-buynow-btnn').css('display','block');
      $(".shopify-payment-button").css('display','none');
    }
  }
});
//================================ productpage modal js==========================//

function onClick(element){
  document.getElementById("modal01").style.display = "block";
}

$("body").on("click",".removeclass img",function(){
  console.log("did");
  $("#modal01 .slick-next.slick-arrow").click();
  $(".grid-image.pro.removeclass").removeClass("removeclass");

});

$('body').on('click','.product__media.media',function(){
  var dataid = $(this).find ('img').attr('data-id');
  setTimeout(function(){ 
    var scrollval = null;
    /*scrollval = $("#modal01 #"+dataid).offset().top;*/
    $('body #modal01').animate({
      scrollTop: scrollval
    }, 500);
  }, 1000);

});  

jQuery(document).ready(function($) {
  var $modal = $('#modal01');

  $modal
  .on('click', '.modal-content', closeModal)
  .on('click', '.close', closeModal)
  .on('click', '.modal-content', function(event) {
    event.stopPropagation(); 
  });

  function closeModal() {
    $modal.fadeOut();
  };

});
